module.exports = __webpack_public_path__ + "media/images/btn-arrow-top-4bbbfc9c8aa9d8050cf8ca852eeb7a17.svg";